import React from 'react'

import LoadingIcon from '../../../assets/icons/loading.svg?react'

type Props = {
  size?: 'fill-container' | 'screen' | 'inline'
  message?: string
  className?: string
  textClassName?: string
  loadingColor?: string
}

const Loading: React.FC<Props> = ({ size, message, className = '', loadingColor = 'deep-green', textClassName = '' }) => {
  let classes = 'flex items-center'

  if (size === 'screen') {
    classes += ' justify-center h-screen'
  } else if (size === 'fill-container') {
    classes += ' justify-center w-full h-full'
  } else if (size === 'inline') {
    classes += ' justify-center'
  }

  return (
    <div className={`${classes} ${className}`}>
      <LoadingIcon className={`animate-spin h-5 w-5 text-${loadingColor} mr-2`} />
      {message && <span className={textClassName}>{message}</span>}
    </div>
  )
}

export default Loading
